export default __webpack_public_path__ + "static/media/PE.6101d45f.svg";